import React, { FC } from 'react'

import { FormikFormProps } from '../../../form/FormikForm'
import { FormSubmitButtonProps } from '../../../form/FormSubmitButton'
import FormikField from '../../../form/FormikField'
import { FormErrorsProps } from '../../../form/FormErrors'
import { CardProps } from '../../../Card'
import { FormFieldInputProps } from '../../../form/fields/FormFieldInput'
import { ActionButtonProps } from '../../../ActionButton'
import { HtmlProps } from '../../../Html'

import * as SC from './styled'

export type TwoFactorAuthValues = {
  code: string
}

export type TwoFactorAuthProps = {
  className?: string
  header: CardProps['header']
  content: {
    title: string
    html: HtmlProps
    formikForm: FormikFormProps<TwoFactorAuthValues>
    fields: {
      code: FormFieldInputProps
    }
    errors?: FormErrorsProps['errors']
    submitButton: FormSubmitButtonProps
    notReceivedCodeButton: ActionButtonProps
  }
}

const TwoFactorAuth: FC<TwoFactorAuthProps> = ({
  className,
  header,
  content: { title, html, formikForm, fields, notReceivedCodeButton, submitButton, errors },
}) => {
  return (
    <SC.CardWrapper className={className} header={header}>
      <SC.Title>{title}</SC.Title>
      <SC.Html {...html} />
      <SC.Form className={className} {...formikForm}>
        <SC.Fields>
          <FormikField {...fields.code} Component={SC.FieldText} />
        </SC.Fields>
        {errors && <SC.Errors errors={errors} />}
        <SC.ButtonsWrapper>
          <SC.NotReceivedCodeButton {...notReceivedCodeButton} />
          <SC.SubmitButton {...submitButton} />
        </SC.ButtonsWrapper>
      </SC.Form>
    </SC.CardWrapper>
  )
}

export default TwoFactorAuth
